import commonService from 'utils/commonService';
import apiService from './apiService';
import { ReturnCode } from 'constants/enums/returnCode.enum';
import { BaseRes } from 'bff/models/base/baseRes';
import { GameQueryReq, GameQueryResp } from 'bff/models/game/gameQuery';
import { GameDodrawReq, GameDodrawResp } from 'bff/models/game/gameDodraw';
import { GameChkqualifyReq, GameChkqualifyResp } from 'bff/models/game/gameChkqualify';

/**
 * @description 查詢可抽獎活動(列表、明細)
 * @param args 上行電文 TRANRQ 內容
 */
const gameQuery = async (args: GameQueryReq) => {
  const baseReq = commonService.getApiReqData(args);
  const reqConfig = commonService.getReqConfig();
  const res: BaseRes<GameQueryResp> = await apiService.gameQuery(baseReq, reqConfig);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 取得抽獎結果
 * @param args 上行電文 TRANRQ 內容
 */
const gameDodraw = async (args: GameDodrawReq) => {
  const baseReq = commonService.getApiReqData(args);
  const reqConfig = commonService.getReqConfig();
  const res: BaseRes<GameDodrawResp> = await apiService.gameDodraw(baseReq, reqConfig);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 檢查是否有符合抽獎資格之抽獎活動
 * @param args 上行電文 TRANRQ 內容
 */
const gameChkqualify = async (args: GameChkqualifyReq) => {
  const baseReq = commonService.getApiReqData(args);
  const reqConfig = commonService.getReqConfig();
  const res: BaseRes<GameChkqualifyResp> = await apiService.gameChkqualify(baseReq, reqConfig);
  // 若非 0000，則不需顯示錯誤訊息 (2025/02/18)
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    return {
      GAMEPOI: '',
      QUALIFIED_DCNT: 0,
      QUALIFIED: []
    };
  } else {
    return res.TRANRS;
  }
};

export default {
  gameQuery,
  gameDodraw,
  gameChkqualify
};
